import type { Intervals, Interval } from "@b2bportal/air-shopping-api";
import {
  IconNameEnum,
  useModuleBEM,
  useTenantIcons,
} from "@b2bportal/core-themes";

import styles from "./styles.module.scss";

export type IntervalKey = keyof Intervals;

interface PricePredictionIntervalProps {
  intervalKey: IntervalKey;
  interval: Interval;
}

const forecastIcons: Record<IntervalKey, IconNameEnum> = {
  normal: IconNameEnum.predictionNormal,
  warning: IconNameEnum.predictionWarning,
  danger: IconNameEnum.predictionDanger,
};

export const PricePredictionInterval = ({
  intervalKey,
  interval,
}: PricePredictionIntervalProps): JSX.Element => {
  const [block, cn] = useModuleBEM(styles, "PricePredictionInterval");

  const icons = useTenantIcons();
  const Icon = icons[forecastIcons[intervalKey]];

  return (
    <div key={intervalKey} className={block}>
      <div className={cn("icon-container")}>{Icon && <Icon />}</div>

      <h4 className={cn("time-period")}>{interval?.dates}</h4>

      <p
        className={cn("copy")}
        dangerouslySetInnerHTML={{
          __html: interval.copy,
        }}
      ></p>
    </div>
  );
};
